module.exports = __webpack_public_path__ + "media/spl.fce77dee.mp4";